// Translation dictionary — Portuguese (default) and English.
// Extend by adding new keys to both objects.

export const dict = {
  pt: {
    nav: {
      canais: "Canais",
      trabalho: "Trabalho",
      sobre: "Sobre",
      marcas: "Marcas",
      servicos: "Serviços",
      parcerias: "Parcerias",
      cta: "Trabalhar Connosco",
      brand_overline: "Criador de Conteúdos · Portugal",
    },
    hero: {
      location: "Aveiro 2026 · Portugal",
      headline_a: "A",
      headline_autenticidade: "Autenticidade",
      headline_destino: "como Destino.",
      headline_marca: "A Sua Marca na Nossa",
      headline_jornada: "Jornada",
      paragraph_1:
        "A Terra & Trilhos é a casa criativa por trás de dois canais de referência no YouTube. Através do",
      paragraph_2: "(Vida na Aldeia e Reconstrução) e do",
      paragraph_3:
        "(Caminhadas e Exploração Histórica), oferecemos às marcas uma integração orgânica em narrativas reais de superação.",
      paragraph_4:
        "Não fazemos apenas vídeos: criamos contexto e autoridade para marcas que querem fazer parte de uma história de",
      paragraph_5: "esforço, tradição e descoberta",
      cta_primary: "Conhecer os Canais",
      cta_secondary: "Propostas para Marcas",
      canal_01: "canal 01 / vida na aldeia",
      canal_02: "canal 02 / aventura",
      scroll: "scroll",
    },
    channels: {
      overline: "os dois canais",
      heading_1: "Dois mundos cinemáticos",
      heading_2: "debaixo do mesmo teto",
      subheading:
        "Cada canal tem audiência, ritmo e linguagem visual próprios — mas partilham a mesma obsessão pela qualidade e pela autenticidade portuguesa.",
      visit: "visitar canal no youtube",
      "viver-na-aldeia": {
        tagline: "Vida na Aldeia, Terra e Tradição Portuguesa.",
        heading_l: "Onde o tempo",
        heading_r: "ganha um novo sentido",
        description:
          "Bem-vindo ao Viver na Aldeia. Mais do que um canal, este é o registo real da nossa vida no Portugal profundo. Aqui, a recuperação de ruínas ganha vida através do DIY e restauro em pedra, enquanto a horta biológica e os animais ditam o ritmo dos nossos dias. Cada vídeo é um diário visual sobre a coragem de voltar à origem — aliando a sabedoria ancestral a uma estética cinematográfica moderna.",
        pillars: [
          "Vida na Aldeia",
          "Restauro Rural & Faz Tu Mesmo",
          "Cultura Portuguesa",
          "Horta & Autossuficiência",
        ],
        community_label: "A Nossa Comunidade em Crescimento",
      },
      "trilhos-em-furia": {
        tagline: "Exploração, Montanha e Trilhos em Estado Puro.",
        heading_l: "Onde a jornada",
        heading_r: "se torna épica",
        description:
          "No Trilhos em Fúria, a exploração não tem limites. Levamos-te pelos trilhos mais desafiantes e paisagens deslumbrantes de Portugal e do mundo — sempre a pé, com a mochila às costas e o espírito de aventura no máximo. De florestas ancestrais a cumes imponentes, cada vídeo é uma narrativa visual de superação e descoberta da natureza selvagem.",
        pillars: [
          "Montanhismo e Caminhada de Montanha",
          "Exploração de Lugares Esquecidos",
          "Cinemática de Aventura & Drone",
          "História & Património Remoto",
        ],
        community_label: "A Nossa Comunidade de Aventureiros",
      },
      stats: {
        subscribers: "subscritores",
        views: "visualizações",
        videos: "vídeos originais",
      },
    },
    videos: {
      overline: "vitrine de vídeos",
      heading_1: "O melhor de cada",
      heading_2: "universo",
      see_more: "Ver mais em",
    },
    stats: {
      overline: "números em pista",
      heading_1: "Audiência",
      heading_2: "construída",
      heading_3: ", não comprada.",
      combined: "universo combinado",
      subscribers_label: "subscritores reais",
      views: "visualizações",
      videos: "vídeos publicados",
      years: "anos no ar",
      subs_short: "subs",
      views_short: "views",
      videos_short: "vídeos",
    },
    about: {
      overline: "sobre o estúdio",
      heading_1: "Uma só pessoa por trás de cada",
      heading_2: "moldura",
      role_overline: "o influencer",
      paragraphs: [
        ["A Terra & Trilhos nasceu da necessidade de documentar o que é autêntico. ", "O Viver na Aldeia", " surgiu para preservar o restauro das nossas raízes: a reconstrução em pedra, a carpintaria DIY e a paciência da horta. É um arquivo vivo que reuniu uma comunidade fiel que procura o regresso ao essencial."],
        ["", "O Trilhos em Fúria", " é a expressão da nossa resiliência. O que começou com o impulso de explorar a serra, tornou-se um dos canais de referência em Portugal para o hiking. Hoje, operamos com padrões de produção elevados — drone, cor cinematográfica, banda sonora premium e narrativa documental — para uma audiência outdoor exigente."],
        ["Como criador e gestor deste ecossistema, opero a 360°: da ideia à realização, da edição à estratégia de marca. É esta entrega total que ofereço aos parceiros que escolhem caminhar com a Terra & Trilhos.", "", ""],
      ],
      metrics_label: "Métricas de Portfólio",
      metrics: {
        videos: "vídeos produzidos",
        partners: "parcerias de valor",
        countries: "países alcançados",
      },
    },
    brands: {
      overline: "confiam em nós",
      heading_1: "Marcas com quem já contámos",
      heading_2: "histórias",
      sub: "Selecção de parceiros nacionais e internacionais que escolheram a Terra & Trilhos para falar com audiências reais.",
    },
    services: {
      overline: "o que fazemos por marcas",
      heading_1: "Não vendemos slots.",
      heading_2: "Construímos",
      heading_3: "narrativas",
      sub: "Cada parceria é desenhada à medida do canal certo, da audiência certa, e do momento certo. Trabalhamos como produtora interna — ideação, realização, edição, métricas. Sem agências no meio. Sem ruído.",
      items: [
        {
          name: "Conteúdo de Marca",
          description:
            "Esquecemos o guião publicitário tradicional para contar histórias onde a sua marca é a protagonista da jornada. Criamos conteúdo narrativo dentro dos universos Viver na Aldeia e Trilhos em Fúria — sem cortes artificiais, focado na verdade e na utilidade real.",
        },
        {
          name: "Teste de Campo & Integração",
          description:
            "Muito mais do que um teste de produto. Posicionamos o seu produto no contexto extremo para o qual foi desenhado — seja no esforço de uma subida ao Gerês ou no rigor de um restauro faz tu mesmo em pedra. Validamos a performance com a autoridade de quem vive o terreno.",
        },
        {
          name: "Produção Audiovisual de Elite",
          description:
            "Oferecemos uma estética documental e cinematográfica. Utilizamos tecnologia de ponta — drone 4K, estabilização avançada e banda sonora premium — para garantir que a identidade visual da sua marca se destaca com uma qualidade de imagem superior.",
        },
        {
          name: "Consultoria de Ecossistema YouTube",
          description:
            "Partilhamos a experiência de quem construiu uma comunidade de milhares de seguidores do zero. Ajudamos marcas a navegar no YouTube, desde a estratégia de retenção à criação de uma narrativa que gera confiança e conversão duradoura.",
        },
      ],
    },
    contact: {
      overline: "contacto",
      heading_1: "Vamos contar a sua próxima",
      heading_2: "história",
      sub:
        "Para propostas de branded content, parcerias e produção. Lemos cada mensagem pessoalmente — não há triagens automáticas.",
      email_label: "email",
      location_label: "localização",
      time_label: "tempo de resposta",
      time_value: "até 48h em dias úteis",
      labels: {
        name: "Nome",
        email: "Email",
        company: "Empresa",
        type: "Tipo de Parceria",
        subject: "Assunto",
        message: "Mensagem",
      },
      placeholders: {
        name: "O seu nome",
        email: "email@empresa.com",
        company: "Nome da empresa (opcional)",
        subject: "Resumo da proposta",
        message:
          "Conte-nos sobre o projecto, briefing, calendário e orçamento aproximado…",
      },
      privacy:
        "Ao enviar, concorda em ser contactado por email. Não partilhamos dados com terceiros.",
      cta_idle: "Enviar mensagem",
      cta_loading: "A enviar…",
      cta_success: "Enviado",
      success_toast: "Mensagem enviada. Respondemos em até 48h.",
      error_toast: "Não foi possível enviar. Tente novamente.",
      validation_toast:
        "Preencha nome, email, assunto e uma mensagem com pelo menos 10 caracteres.",
      interests: [
        "Conteúdo de Marca",
        "Teste de Campo & Integração",
        "Produção Audiovisual de Elite",
        "Consultoria de Ecossistema YouTube",
        "Outro",
      ],
    },
    footer: {
      cta_l: "Vamos trabalhar",
      cta_r: "juntos.",
      tagline:
        "Casa criativa de storytelling rural e aventura outdoor. Filmamos Portugal a partir de dentro.",
      channels_label: "canais",
      nav_label: "navegação",
      copyright: "Todos os direitos reservados.",
      credit: "design & code · in-house",
      nav: {
        canais: "Canais",
        trabalho: "Trabalho",
        sobre: "Sobre",
        marcas: "Marcas",
        servicos: "Serviços",
        contacto: "Contacto",
      },
    },
    why: {
      overline: "porquê a Terra & Trilhos",
      heading_1: "Porque é que as marcas nos",
      heading_2: "escolhem",
      cards: [
        {
          title: "Storytelling Autêntico",
          desc: "Os produtos são integrados de forma natural em experiências reais — nunca como publicidade tradicional.",
        },
        {
          title: "Produção Profissional",
          desc: "Cinematografia de alta qualidade, filmagem com drone e edição profissional em cada vídeo.",
        },
        {
          title: "Elevada Confiança da Audiência",
          desc: "Conteúdo long-form no YouTube focado em autenticidade, credibilidade e utilidade real.",
        },
        {
          title: "Especialização: Aventura e Renovação",
          desc: "Audiência especializada em vida outdoor, ferramentas, tecnologia, energia renovável e renovação de casas.",
        },
        {
          title: "Experiência com Marcas Internacionais",
          desc: "Colaborações anteriores com empresas internacionais como Reolink, Allpowers, Einhell e Bluetti.",
        },
        {
          title: "Parcerias de Longo Prazo",
          desc: "Focamo-nos em construir relações duradouras, não apenas vídeos patrocinados pontuais.",
        },
      ],
    },
    events: {
      overline: "cobertura de eventos",
      heading_1: "Cobertura de Feiras",
      heading_2: "Internacionais",
      sub: "A presença em feiras internacionais permite-nos criar conteúdo autêntico e de alto impacto directamente dos maiores eventos da indústria.",
      offer_title: "O que oferecemos",
      offers: [
        "Visita a Stands",
        "Cobertura de Lançamentos de Produto",
        "Entrevistas com Equipas",
        "Demonstrações Primeiras Impressões",
        "Vlogs Diários do Evento",
        "YouTube Shorts",
        "Instagram Reels",
      ],
      badge_label: "Disponível para",
      venues: ["IFA Berlin", "CES Las Vegas", "Eurobike", "Outdoor by ISPO"],
      cta: "Reservar Cobertura de Evento",
    },
    services_extra: {
      sub: "Oportunidades de Parceria",
      items: [
        "Vídeo YouTube Dedicado",
        "Patrocínio Integrado",
        "Review de Produto",
        "Embaixador de Marca a Longo Prazo",
        "Cobertura de Feira",
        "Fotografia",
        "Filmagem com Drone",
        "Conteúdo para Redes Sociais",
      ],
      cta: "Solicitar Colaboração",
    },
    proof: {
      overline: "confiam em nós",
      heading_1: "Confiados por Marcas",
      heading_2: "Globais",
      stats: [
        { value: 15, suffix: "+", label: "Colaborações com Marcas" },
        { value: 100, suffix: "%", label: "Integrações Autênticas" },
        { value: 2, suffix: "", label: "Canais YouTube · Produção Profissional" },
      ],
    },
    contact_extra: {
      title_l: "Vamos Construir Algo",
      title_r: "Extraordinário",
      sub:
        "Quer esteja a lançar um novo produto, a marcar presença numa feira internacional ou à procura de storytelling autêntico — queremos ouvir sobre o seu projecto.",
      response_label: "Tempo médio de resposta",
      response_value: "até 24 horas",
      cta_alt: "Reservar Parceria",
    },
    trusted: {
      overline: "",
      title: "Confiados por Marcas Internacionais de Referência",
      description:
        "Orgulhamo-nos de colaborar com marcas globalmente reconhecidas nas áreas de tecnologia, energia renovável, construção, ferramentas e melhoria de habitação — criando conteúdo autêntico que liga os produtos a experiências reais.",
      caption:
        "Confiados por marcas comprometidas com qualidade, inovação e storytelling autêntico.",
    },
    kit: {
      nav_back: "Voltar ao site",
      hero: {
        eyebrow: "TERRA & TRILHOS",
        title: "Brand Partnership Kit",
        subtitle: "Storytelling autêntico. Aventura real. Conteúdo premium.",
        cta: "Trabalhar Connosco",
        meta: "Media Kit · Edição 2026",
      },
      who: {
        overline: "01 · who we are",
        title: "Uma casa criativa portuguesa.",
        p1: "A Terra & Trilhos é uma media brand portuguesa dedicada à produção de conteúdo long-form premium — histórias reais, filmadas e editadas com padrões cinematográficos.",
        p2: "Operamos em cinco universos: Outdoor · Adventure · Travel · DIY & Home Renovation · Technology & Storytelling.",
        p3: "Uma equipa independente, focada em construir parcerias de longo prazo com marcas que valorizam autenticidade e presença duradoura.",
        role: "Eduardo Moreira · Founder & Creator",
      },
      channels: {
        overline: "02 · our channels",
        title: "Dois canais. Uma só voz.",
        subs: "Subscritores",
        views: "Visualizações totais",
        watch: "Horas assistidas",
      },
      audience: {
        overline: "03 · audience",
        title: "Uma audiência internacional e qualificada.",
        countries_label: "Principais mercados",
        demo_label: "Perfil demográfico",
        interests_label: "Áreas de interesse",
        male: "Predominantemente masculino",
        age: "35–64 anos",
        countries: ["Portugal", "Brasil", "França", "Suíça", "Reino Unido", "Estados Unidos"],
        interests: [
          "DIY",
          "Outdoor",
          "Construção",
          "Aventura",
          "Tecnologia",
          "Energia Renovável",
          "Viagem",
        ],
      },
      performance: {
        overline: "04 · performance",
        title: "Números reais. Auditáveis.",
        caption: "Dados YouTube Studio — últimos 12 meses.",
        metrics: {
          subs: "Subscritores",
          views: "Visualizações",
          watch: "Horas assistidas",
          impressions: "Impressões",
          ctr: "CTR",
        },
      },
      content: {
        overline: "05 · content pillars",
        title: "O que produzimos.",
        pillars: [
          "Outdoor Adventure",
          "DIY",
          "Technology",
          "Travel",
          "Home Renovation",
          "Product Reviews",
          "Drone Cinematography",
        ],
      },
      trusted_title: "Confiados por marcas internacionais",
      why: {
        overline: "07 · why us",
        title: "Porquê a Terra & Trilhos.",
        items: [
          "Storytelling Autêntico",
          "Cinematografia Profissional",
          "Conteúdo Long-form Perene",
          "Elevada Confiança da Audiência",
          "Integração Natural de Produto",
          "Produção com Drone",
          "Fotografia de Produto",
          "Cobertura de Eventos Internacionais",
          "Expertise no Mercado Português",
          "Audiência Europeia",
        ],
      },
      opps: {
        overline: "08 · partnership opportunities",
        title: "Formatos disponíveis.",
        items: [
          "Vídeo YouTube Dedicado",
          "Patrocínio Integrado",
          "Review de Produto",
          "Parceria de Longo Prazo",
          "Cobertura de Feira",
          "Booth Tour",
          "Cobertura de Evento",
          "Fotografia",
          "Conteúdo Drone",
          "Instagram Reels",
          "YouTube Shorts",
          "Campanhas de Afiliação",
        ],
      },
      events: {
        overline: "09 · trade shows",
        title: "Cobertura Internacional de Eventos.",
        text:
          "A Terra & Trilhos está disponível para feiras internacionais, lançamentos de produto, booth tours, entrevistas e storytelling em directo.",
        upcoming_label: "Confirmados",
        future_label: "Futuras edições",
      },
      contact: {
        overline: "10 · let's talk",
        title_l: "Vamos construir algo",
        title_r: "extraordinário.",
        website_label: "Website",
        email_label: "Email",
        ig_label: "Instagram",
        qr_hint: "Aponte a câmara · abrir o site",
      },
    },
  },

  en: {
    nav: {
      canais: "Channels",
      trabalho: "Work",
      sobre: "About",
      marcas: "Brands",
      servicos: "Services",
      parcerias: "Partnerships",
      cta: "Work With Us",
      brand_overline: "Content Creators · Portugal",
    },
    hero: {
      location: "Aveiro 2026 · Portugal",
      headline_a: "",
      headline_autenticidade: "Authenticity",
      headline_destino: "as a Destination.",
      headline_marca: "Your Brand in Our",
      headline_jornada: "Journey",
      paragraph_1:
        "Terra & Trilhos is the creative house behind two reference YouTube channels in Portugal. Through",
      paragraph_2: "(Slow Living and Restoration) and",
      paragraph_3:
        "(Hiking and Historical Exploration), we offer brands an organic integration into real narratives of grit and discovery.",
      paragraph_4:
        "We don't just make videos: we craft context and authority for brands that want to be part of a story of",
      paragraph_5: "effort, tradition and discovery",
      cta_primary: "Discover the Channels",
      cta_secondary: "For Brands",
      canal_01: "channel 01 / slow",
      canal_02: "channel 02 / wild",
      scroll: "scroll",
    },
    channels: {
      overline: "the two channels",
      heading_1: "Two cinematic worlds",
      heading_2: "under one roof",
      subheading:
        "Each channel has its own audience, rhythm and visual language — yet they share the same obsession with quality and Portuguese authenticity.",
      visit: "visit channel on youtube",
      "viver-na-aldeia": {
        tagline: "Slow Living, Land and Portuguese Tradition.",
        heading_l: "Where time",
        heading_r: "finds new meaning",
        description:
          "Welcome to Viver na Aldeia. More than a channel, this is the real record of our life in deep rural Portugal. Here, the recovery of ruins comes alive through DIY and stone restoration, while the organic vegetable garden and animals set the rhythm of our days. Each video is a visual journal about the courage of returning to the origin — pairing ancestral wisdom with a modern cinematic aesthetic.",
        pillars: [
          "Slow Living",
          "Rural Restoration & DIY",
          "Portuguese Culture",
          "Garden & Self-Sufficiency",
        ],
        community_label: "Our Growing Community",
      },
      "trilhos-em-furia": {
        tagline: "Exploration, Mountain and Trails in Pure Form.",
        heading_l: "Where the journey",
        heading_r: "becomes epic",
        description:
          "On Trilhos em Fúria, exploration has no limits. We take you through the most challenging trails and breathtaking landscapes of Portugal and the world — always on foot, backpack on our shoulders and the spirit of adventure at full power. From ancient forests to imposing summits, every video is a visual narrative of overcoming and wild discovery.",
        pillars: [
          "Mountain Hiking & Trekking",
          "Exploration of Forgotten Places",
          "Adventure & Drone Cinematography",
          "History & Remote Heritage",
        ],
        community_label: "Our Community of Adventurers",
      },
      stats: {
        subscribers: "subscribers",
        views: "views",
        videos: "original videos",
      },
    },
    videos: {
      overline: "video showcase",
      heading_1: "The best of each",
      heading_2: "universe",
      see_more: "See more on",
    },
    stats: {
      overline: "the numbers",
      heading_1: "An audience",
      heading_2: "built",
      heading_3: ", not bought.",
      combined: "combined universe",
      subscribers_label: "real subscribers",
      views: "views",
      videos: "videos published",
      years: "years on air",
      subs_short: "subs",
      views_short: "views",
      videos_short: "videos",
    },
    about: {
      overline: "about the studio",
      heading_1: "One person behind every",
      heading_2: "frame",
      role_overline: "the creator",
      paragraphs: [
        ["Terra & Trilhos was born from the need to document what is authentic. ", "Viver na Aldeia", " emerged to preserve the restoration of our roots: stone reconstruction, DIY carpentry and the patience of the garden. It's a living archive that gathered a loyal community searching for the return to essentials."],
        ["", "Trilhos em Fúria", " is the expression of our resilience. What started with the impulse to explore the mountains has become one of Portugal's reference channels for hiking. Today we operate with elevated production standards — drone, cinematic color, premium soundtrack and documentary narrative — for a demanding outdoor audience."],
        ["As creator and manager of this ecosystem, I operate end-to-end: from idea to realization, from edit to brand strategy. This full commitment is what I offer to partners who choose to walk alongside Terra & Trilhos.", "", ""],
      ],
      metrics_label: "Portfolio Metrics",
      metrics: {
        videos: "videos produced",
        partners: "valuable partnerships",
        countries: "countries reached",
      },
    },
    brands: {
      overline: "they trust us",
      heading_1: "Brands we've already told",
      heading_2: "stories with",
      sub: "A selection of national and international partners that chose Terra & Trilhos to speak with real audiences.",
    },
    services: {
      overline: "what we do for brands",
      heading_1: "We don't sell slots.",
      heading_2: "We build",
      heading_3: "narratives",
      sub: "Each partnership is tailored for the right channel, the right audience, the right moment. We work as an in-house production studio — ideation, direction, editing, metrics. No agencies in between. No noise.",
      items: [
        {
          name: "Branded Storytelling",
          description:
            "We move past the traditional ad script to tell stories where your brand is the protagonist of the journey. We create narrative content inside the Viver na Aldeia and Trilhos em Fúria universes — no artificial cuts, focused on truth and real utility.",
        },
        {
          name: "Field Test & Integration",
          description:
            "Far more than a product placement. We position your product in the extreme context for which it was designed — whether on a climb up Gerês or in the rigor of a stone DIY restoration. We validate performance with the authority of those who live the terrain.",
        },
        {
          name: "Elite Audiovisual Production",
          description:
            "We deliver a documentary, cinematic aesthetic. Cutting-edge tech — 4K drone, advanced stabilization and premium soundtrack — ensures your brand's visual identity stands out with superior image quality.",
        },
        {
          name: "YouTube Ecosystem Consulting",
          description:
            "We share the experience of having built a community of thousands of followers from zero. We help brands navigate YouTube, from retention strategy to crafting a narrative that drives lasting trust and conversion.",
        },
      ],
    },
    contact: {
      overline: "contact",
      heading_1: "Let's tell your next",
      heading_2: "story",
      sub:
        "For branded content, partnerships and production proposals. We read every message personally — no automatic filters.",
      email_label: "email",
      location_label: "location",
      time_label: "response time",
      time_value: "within 48h on business days",
      labels: {
        name: "Name",
        email: "Email",
        company: "Company",
        type: "Partnership Type",
        subject: "Subject",
        message: "Message",
      },
      placeholders: {
        name: "Your name",
        email: "you@company.com",
        company: "Company name (optional)",
        subject: "Proposal summary",
        message:
          "Tell us about the project, brief, timeline and approximate budget…",
      },
      privacy:
        "By submitting, you agree to be contacted by email. We do not share data with third parties.",
      cta_idle: "Send message",
      cta_loading: "Sending…",
      cta_success: "Sent",
      success_toast: "Message sent. We'll reply within 48h.",
      error_toast: "Could not send. Please try again.",
      validation_toast:
        "Please fill in name, email, subject and a message with at least 10 characters.",
      interests: [
        "Branded Storytelling",
        "Field Test & Integration",
        "Elite Audiovisual Production",
        "YouTube Ecosystem Consulting",
        "Other",
      ],
    },
    footer: {
      cta_l: "Let's work",
      cta_r: "together.",
      tagline:
        "Creative house for rural storytelling and outdoor adventure. We film Portugal from within.",
      channels_label: "channels",
      nav_label: "navigation",
      copyright: "All rights reserved.",
      credit: "design & code · in-house",
      nav: {
        canais: "Channels",
        trabalho: "Work",
        sobre: "About",
        marcas: "Brands",
        servicos: "Services",
        contacto: "Contact",
      },
    },
    why: {
      overline: "why terra & trilhos",
      heading_1: "Why Brands Choose",
      heading_2: "Terra & Trilhos",
      cards: [
        {
          title: "Authentic Storytelling",
          desc: "Products are naturally integrated into real-life experiences instead of traditional advertisements.",
        },
        {
          title: "Professional Production",
          desc: "High quality cinematography, drone footage and professional editing on every video.",
        },
        {
          title: "High Audience Trust",
          desc: "Long-form YouTube content focused on authenticity, credibility and real utility.",
        },
        {
          title: "Outdoor & Home Improvement Expertise",
          desc: "Specialized audience interested in outdoor living, tools, technology, renewable energy and home renovation.",
        },
        {
          title: "International Brand Experience",
          desc: "Previous collaborations with international companies such as Reolink, Allpowers, Einhell and Bluetti.",
        },
        {
          title: "Long-Term Partnerships",
          desc: "Focus on building long-term relationships rather than one-off sponsored videos.",
        },
      ],
    },
    events: {
      overline: "event coverage",
      heading_1: "International Trade Show",
      heading_2: "Coverage",
      sub: "Attending international trade shows allows us to create authentic, high-impact content directly from the industry's biggest events.",
      offer_title: "We offer",
      offers: [
        "Booth Tours",
        "Product Launch Coverage",
        "Team Interviews",
        "Hands-on Demonstrations",
        "Daily Event Vlogs",
        "YouTube Shorts",
        "Instagram Reels",
      ],
      badge_label: "Available for",
      venues: ["IFA Berlin", "CES Las Vegas", "Eurobike", "Outdoor by ISPO"],
      cta: "Book Event Coverage",
    },
    services_extra: {
      sub: "Partnership Opportunities",
      items: [
        "Dedicated YouTube Video",
        "Integrated Sponsorship",
        "Product Review",
        "Long-Term Brand Ambassador",
        "Trade Show Coverage",
        "Photography",
        "Drone Footage",
        "Social Media Content",
      ],
      cta: "Request Collaboration",
    },
    proof: {
      overline: "trusted by",
      heading_1: "Trusted by Global",
      heading_2: "Brands",
      stats: [
        { value: 15, suffix: "+", label: "Brand Collaborations" },
        { value: 100, suffix: "%", label: "Authentic Integrations" },
        { value: 2, suffix: "", label: "YouTube Channels · Professional Content Production" },
      ],
    },
    contact_extra: {
      title_l: "Let's Build Something",
      title_r: "Remarkable Together",
      sub:
        "Whether you're launching a new product, attending an international exhibition, or looking for authentic storytelling, we'd love to hear about your project.",
      response_label: "Average response time",
      response_value: "within 24 hours",
      cta_alt: "Book a Partnership",
    },
    trusted: {
      overline: "trusted by",
      title: "Trusted by Leading International Brands",
      description:
        "We're proud to collaborate with globally recognized brands across technology, renewable energy, construction, tools and home improvement, creating authentic content that connects products with real-world experiences.",
      caption:
        "Trusted by brands committed to quality, innovation and authentic storytelling.",
    },
    kit: {
      nav_back: "Back to site",
      hero: {
        eyebrow: "TERRA & TRILHOS",
        title: "Brand Partnership Kit",
        subtitle: "Authentic Storytelling. Real Adventures. Premium Content.",
        cta: "Work With Us",
        meta: "Media Kit · 2026 Edition",
      },
      who: {
        overline: "01 · who we are",
        title: "A Portuguese creative house.",
        p1: "Terra & Trilhos is a Portuguese media brand dedicated to premium long-form content — real stories, filmed and edited to cinematic standards.",
        p2: "We operate across five universes: Outdoor · Adventure · Travel · DIY & Home Renovation · Technology & Storytelling.",
        p3: "An independent team focused on building long-term partnerships with brands that value authenticity and lasting presence.",
        role: "Eduardo Moreira · Founder & Creator",
      },
      channels: {
        overline: "02 · our channels",
        title: "Two channels. One voice.",
        subs: "Subscribers",
        views: "Lifetime Views",
        watch: "Watch Hours",
      },
      audience: {
        overline: "03 · audience",
        title: "An international, qualified audience.",
        countries_label: "Top markets",
        demo_label: "Demographic profile",
        interests_label: "Interest areas",
        male: "Predominantly male",
        age: "35–64 years old",
        countries: ["Portugal", "Brazil", "France", "Switzerland", "United Kingdom", "United States"],
        interests: [
          "DIY",
          "Outdoor",
          "Construction",
          "Adventure",
          "Technology",
          "Renewable Energy",
          "Travel",
        ],
      },
      performance: {
        overline: "04 · performance",
        title: "Real numbers. Auditable.",
        caption: "YouTube Studio data — last 12 months.",
        metrics: {
          subs: "Subscribers",
          views: "Lifetime Views",
          watch: "Watch Hours",
          impressions: "Impressions",
          ctr: "CTR",
        },
      },
      content: {
        overline: "05 · content pillars",
        title: "What we produce.",
        pillars: [
          "Outdoor Adventure",
          "DIY",
          "Technology",
          "Travel",
          "Home Renovation",
          "Product Reviews",
          "Drone Cinematography",
        ],
      },
      trusted_title: "Trusted by leading international brands",
      why: {
        overline: "07 · why us",
        title: "Why Terra & Trilhos.",
        items: [
          "Authentic Storytelling",
          "Professional Cinematography",
          "Long-form Evergreen Content",
          "High Audience Trust",
          "Natural Product Integration",
          "Drone Production",
          "Product Photography",
          "International Event Coverage",
          "Portuguese Market Expertise",
          "European Audience",
        ],
      },
      opps: {
        overline: "08 · partnership opportunities",
        title: "Available formats.",
        items: [
          "Dedicated YouTube Video",
          "Integrated Sponsorship",
          "Product Review",
          "Long-Term Partnership",
          "Trade Show Coverage",
          "Booth Tour",
          "Event Coverage",
          "Photography",
          "Drone Content",
          "Instagram Reels",
          "YouTube Shorts",
          "Affiliate Campaigns",
        ],
      },
      events: {
        overline: "09 · trade shows",
        title: "International Event Coverage.",
        text:
          "Terra & Trilhos is available for international trade shows, product launches, booth tours, interviews and live event storytelling.",
        upcoming_label: "Confirmed",
        future_label: "Future editions",
      },
      contact: {
        overline: "10 · let's talk",
        title_l: "Let's build something",
        title_r: "remarkable together.",
        website_label: "Website",
        email_label: "Email",
        ig_label: "Instagram",
        qr_hint: "Scan · open the site",
      },
    },
  },
};
